import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=21793a2a&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=21793a2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21793a2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21793a2a')) {
      api.createRecord('21793a2a', component.options)
    } else {
      api.reload('21793a2a', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=21793a2a&scoped=true&", function () {
      api.rerender('21793a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Cw9q0kjUAE7z/JS/comp/PopupDialog.vue"
export default component.exports